<template>
  <CCheckbox :checked="checked" @update:checked="toggleFilter()" @keyup.enter="toggleFilter()">
    <CText el="span" variant="system-sm" class="text-gray-800"> {{ checkboxText }}</CText>
  </CCheckbox>
</template>

<script setup lang="ts">
type Props = {
  filter?: Record<string, string>;
  facetName?: string;
  checkboxText?: string;
  checked?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  filter: () => ({}),
  facetName: '',
  checkboxText: '',
  checked: false,
});

const route = useRoute();
const router = useRouter();

const toggleFilter = () => {
  const query = { ...route.query };
  if (query[props.facetName]) {
    delete query[props.facetName];
  } else {
    Object.assign(query, props.filter);
  }

  const newRoute = {
    path: route.path,
    query,
  };

  router.push(newRoute);
};
</script>

<script lang="ts">
export default defineComponent({
  name: 'SideNavSingleValueFilter',
});
</script>
